import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SharedFunctions } from '../../shared/shared.functions';

import { TipoEnvioService, MenuFuncionService } from '../../shared/services';
import { DialogConfirmRequest, DialogConfirmResponse, MenuFuncionCodes, TipoEnvio, SaveTipoEnvioDto, CondicionAplicacionImpuestosConstants, VariableCalculoConstants } from '../../shared/model';
import { DialogConfirmComponent } from '../../shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-tipoEnvioEdit',
  templateUrl: './tipoEnvioEdit.component.html',
  styles: [ ]
})

export class TipoEnvioEditComponent implements OnInit {
  formGroup: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;

  canView: boolean = false;
  canAdd: boolean = false;
  canEdit: boolean = false;
  canDelete: boolean = false;

  condicionAplicacionImpuestosList: any[];
  variableCalculoIvaList: any[];

  msgError: string = "";
  item: TipoEnvio;

  constructor (
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private tipoEnvioService: TipoEnvioService) {
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.TIPO_ENVIO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.canEdit = data.Result.some(x => x == MenuFuncionCodes.TIPO_ENVIO_EDIT);
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.TIPO_ENVIO_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.TIPO_ENVIO_LIST);
        this.canDelete = data.Result.some(x => x == MenuFuncionCodes.TIPO_ENVIO_DELETE);
        this.loadView();
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();
    this.loadEntity();

    this.getCondicionAplicacionImpuestosList();
    this.getVariableCalculoIvaList();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Codigo': [null, [Validators.required, Validators.maxLength(100)]],
      'Nombre': [null, [Validators.required, Validators.maxLength(100)]],
      'Comentario': [null, [Validators.maxLength(200)]],
      'MontoTopeMinimo': [null],
      'MontoTopeMaximo': [null],
      'CondicionAplicacionImpuestos': [null, Validators.required],
      'VariableCalculoIva': [null, Validators.required],
      'VariableCalculoIvaExcedente': [null],
      'Activo': [true, Validators.required]
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  getCondicionAplicacionImpuestosList() {
    this.condicionAplicacionImpuestosList = [
      { Id: CondicionAplicacionImpuestosConstants.Nunca, Nombre: "Nunca" },
      { Id: CondicionAplicacionImpuestosConstants.Siempre, Nombre: "Siempre" },
      { Id: CondicionAplicacionImpuestosConstants.SoloEnExcesos, Nombre: "Solo En Excesos" }
    ];
  }

  getVariableCalculoIvaList() {
    this.variableCalculoIvaList = [
      { Id: VariableCalculoConstants.BaseImponibleIva, Nombre: "Base Imponible IVA" },
      { Id: VariableCalculoConstants.ValorImponibleAduana, Nombre: "Valor Imponible Aduana" }
    ];
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
          if (this.canView || this.canEdit) {
            this.isSearching = true;
            this.tipoEnvioService.get(id).subscribe(data => {
              this.isSearching = false;
              if (data != null && data.Success) {
                this.item = data.Result;

                if (this.item != null && this.item.Id > 0) {
                  this.formGroup.patchValue(this.item);
                }
                else
                  this.msgError = "No se encontró el item seleccionado.";
              }
              else
                this.msgError = "Ocurrió un error al intentar obtener los datos del item.";
            },
            (err: HttpErrorResponse) => {
              this.isSearching = false;
              this.sharedFunctions.handleError(err, true);
            })
          }
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
        }
        else
          this.msgError = "Item no válido.";
      }
      else {
        if (this.canAdd) {
          this.item = new TipoEnvio(0, "", "", "", null, null, 0, "", 0, "", null, "", true)
          this.formGroup.patchValue(this.item);
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel(); 
        }
      }
    });
  }

  getErrorCodigo() {
    var v = this.formGroup.get('Codigo');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorNombre() {
    var v = this.formGroup.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorCondicionAplicacionImpuestos() {
    var v = this.formGroup.get('CondicionAplicacionImpuestos');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorVariableCalculoIva() {
    var v = this.formGroup.get('VariableCalculoIva');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorComentario() {
    var v = this.formGroup.get('Comentario');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 200 caracteres alcanzado';
    return '';
  }

  onGuardar() {

    var codigoFormField = this.formGroup.get("Codigo");
    if (codigoFormField?.value == null || codigoFormField?.value.length == 0)
      this.formGroup.get("Codigo")?.setValue(this.formGroup.get("Nombre")?.value);

    var nombreFormField = this.formGroup.get("Nombre");
    if (nombreFormField?.value == null || nombreFormField?.value.length == 0)
      this.formGroup.get("Nombre")?.setValue(this.formGroup.get("Codigo")?.value);
    
    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new SaveTipoEnvioDto("", "", "", null, null, 0, 0, null, true);

    r = 
    {
      ...this.formGroup.value,
      ...{
        Id: (this.item?.Id ?? 0),
        Activo: this.item.Activo
      }
    };

    this.isSaving = true;
    this.tipoEnvioService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onDelete() {
    if (!this.canDelete)
        return false;

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest("", "¿Está seguro que desea eliminar el item?", "", "")
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isDeleting = true;
        this.tipoEnvioService.delete(this.item.Id).subscribe(data => {
          this.isDeleting = false;
          if (data != null && data.Success && data.Result) {
            this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
            this.onCancel();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isDeleting = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }

  onCancel() {
    this.location.back();
  }
}
